import { useState } from "react";

const SimpleResourceFieldViewer = ({ resource, parentElement, parentParentElement, startExpanded }) => {

    const [expandedState, setExpandedState] = useState(startExpanded || false);

    return <span className="pagecontent">

        {resource && <span className={"unselectable"} style={{ cursor: "pointer" }}
            onClick={() => { setExpandedState(!expandedState) }}>
            {expandedState ?
                <>
                    {!parentElement ?
                        <span className="expandOrCollapse">Collapse ▼</span>
                        :
                        <> ▼</>
                    }
                </>
                :
                <>
                    {!parentElement ?
                        <span className="expandOrCollapse">Expand ►</span>
                        :
                        <> ►</>
                    }
                </>
            }
        </span>
        }

        {resource && expandedState && Object.keys(resource).map((field, index) => {
            let reference = "";
            if (field === "reference") {
                let slashesFound = resource[field].toString().match(/\//g);
                if (slashesFound?.length === 1) {
                    reference = resource[field];
                }
            }
            let fli;
            if ((parentParentElement === "identifier" || parentElement === "identifier") && field === "value") {
                if (resource.system?.toLowerCase() === "https://fevir.net/fli" || resource.type?.text === "FEvIR Linking Identifier") {
                    fli = resource[field];
                }
            }
            return <div key={index}
                style={{ paddingLeft: "40px", wordBreak: "break-word" }}>
                {resource[field] !== "" &&
                    <>
                        {typeof resource[field] !== "object" ?
                            <>
                                {reference ?
                                    <span name={field}>
                                        <b>{field}: </b>
                                        <a href={"/resources/" + reference}
                                            target="_blank" rel="noopener noreferrer">{reference}</a>
                                        <br />
                                    </span>
                                    :
                                    <>{fli ?
                                        <span name={field}>
                                            <b>{field}: </b>
                                            <a href={"/FLI/" + fli}
                                                target="_blank" rel="noopener noreferrer">{resource[field].toString()}</a>
                                            <br />
                                        </span>
                                        :
                                        <>{(field === "@id" || field === "@type") &&
                                            resource[field].toLowerCase().substring(0, 4) === "http" ?
                                            <span name={field}>
                                                <b>{field}: </b>
                                                <a href={resource[field]}
                                                    target="_blank" rel="noopener noreferrer">{resource[field]}</a>
                                                <br />
                                            </span>
                                            :
                                            <span name={field}>
                                                {resource[field] !== undefined &&
                                                    <><b>{field}: </b><span>{resource[field].toString()}</span><br /></>}
                                            </span>
                                        }</>
                                    }</>
                                }
                            </>
                            :
                            <span>
                                <b>{isNaN(field) ? field : parentElement + " " + (parseInt(field)).toString()}: </b>
                                <SimpleResourceFieldViewer resource={resource[field]}
                                    parentElement={field}
                                    parentParentElement={parentElement}
                                    startExpanded={true} />
                            </span>
                        }
                    </>
                }
            </div>
        }
        )}
    </span>
}

export default SimpleResourceFieldViewer;